import { CurrentUserFragment, UserRolePermission } from "../../../graphql";
import useFeatureFlag from "../../../graphql/hooks/useFeatureFlag";

const useUserCanAccessRediscovery = (
  currentUser: CurrentUserFragment
): boolean => {
  const rediscoveryEnabled = useFeatureFlag("rediscovery:v1");
  const userPermitted = currentUser.userRole?.permissions?.includes(
    UserRolePermission.EditAiTaskConfiguration
  );

  return !!(rediscoveryEnabled && userPermitted);
};

export default useUserCanAccessRediscovery;
